import { localStorageService } from '../../helpers'
import { USER_SET, USER_UNSET } from './constants'

const def_initialState = {
  id: 0,
  email: '',
  full_name: '',
  roles: [],
  access_token: '',
  refresh_token: '',
}

const initialState = localStorageService.getUser() || def_initialState

export default (state = initialState, action) => {
  switch (action.type) {
    case USER_SET:
      return action.payload
    case USER_UNSET:
      localStorageService.setUser(def_initialState)
      return def_initialState
    default:
      return state
  }
}
